






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListChubunrui from '@/components/common/search/ListChubunrui.vue';
import { API_SEARCH_CHUBUNRUI } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlChubunrui',
  props: {
    mukoUmuFlg: {
      type: Number,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '品目中分類',
    },
    widthCd: {
      type: Number,
      default: 99, //42,
    },
    widthName: {
      type: Number,
      default: 289,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListChubunrui,
  },
  data: () => ({
    API_SEARCH_CHUBUNRUI,
    listChubunruiShow: false,
    chubunruiCd: 0,
    chubunruiMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        // overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { chubunruiCd, chubunruiMei } = item;
      this.chubunruiCd = chubunruiCd;
      this.chubunruiMei = chubunruiMei;
      this.listChubunruiShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listChubunruiShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.chubunruiCd = value;
      if (value) {
        this.getChubunruiItem();
      } else {
        this.chubunruiMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ chubunruiCd: this.chubunruiCd });
      }
    },
    getChubunruiItem() {
      axios
        .get(API_SEARCH_CHUBUNRUI, {
          params: {
            chubunruiCd: this.chubunruiCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.chubunruiMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ chubunruiCd: this.chubunruiCd });
            return;
          }
          this.errors = clearNoDataError();
          const { chubunruiMei } = res.data.responseData[0];
          this.chubunruiMei = chubunruiMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [chubunruiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.chubunruiCd': {
      handler(newValue) {
        if(+newValue === +this.chubunruiCd) return;
        this.chubunruiCd = +newValue;
        if (newValue) {
          this.getChubunruiItem();
        } else {
          this.chubunruiMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.chubunruiCd) {
      this.chubunruiCd = +this.$attrs.chubunruiCd;
    }
  },
});
